<template>
  <div class="action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="960px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <rich-text-editor
          :initial-content="editorContent"
          @change="handleContentChange"
          @save="handleSaveContent"
          @cancel="handleCancelContent"
      />
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import RichTextEditor from '@/components/RichTextEditor'

export default {
  components: {
    RichTextEditor
  },
  data() {
    return {
      editorContent: '请输入内容',
      dialogVisible: false,
      title: "更新帖子",
      // 提交状态
      flag: false,
      id: "",
      // 回复评论的参数
      params: {
        uid: "",
        level: 2,
        summary: "",
      },
    };
  },
  methods: {
    handleContentChange(content) {
      this.params.summary = content.replaceAll("<p><br></p>",'<div class="ri_empty"></div>');
    },
    handleSaveContent(content) {
     this.params.summary = content.replaceAll("<p><br></p>",'<div class="ri_empty"></div>');
     this.sendComment()
    },
    handleCancelContent() {
      this.handleClose()
    },
    sendComment() {
      const params = Object.assign({}, this.params);
      API.replyContent(params)
        .then((res) => {
          (res.code === 200 &&
            (this.$message.success("帖子内容更新成功！"),
            this.handleClose(),
            this.$emit("handleList"))) ||
            this.$message.error("操作失败，请重试");
        })
        .catch(() => {
          this.$message.error("操作失败，请重试");
        })
        .finally(() => {
          this.params.summary = "";
        });
    },
    // 关闭弹窗
    handleClose() {
      this.params = {
        id: "",
        summary: "",
      };
      this.dialogVisible = false;
      this.editorContent = '请输入内容'
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.params = {
        id: data.id,
        summary: data.summary,
      };
      this.dialogVisible = true;
      this.editorContent= data.summary
    },
  },
};
</script>
